// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__34H9U","imageUploader":"EGiftCard_imageUploader__w_6S2"};